import React from 'react'
import { localsMessages } from '../utility/getTemplateData'

let PropTypes = React.PropTypes

export default React.createClass({

    propTypes:{
        label: React.PropTypes.string
    },

    render () {
      
      const guestMessages = localsMessages('common/pPLogIn') || {}
      const havePPLabel = guestMessages.label && guestMessages.label.havePP || ''
      const logInLabel = guestMessages.label && guestMessages.label.logIn || ''

      return (
        <div>
          <div className="row text-center donate_pp_login_wrapper">
            <div className="col-xs-7 col-sm-7 col-md-7 have_pp_label">
              <p className="have_pp_text" id="havePPAccText">{havePPLabel}</p>
            </div>
            <div className="col-xs-5 col-sm-5 col-md-5">
              <a className="btn btn-primary have_pp_btn" id="payWithPP" onClick={this.props.handleLogIn}>{logInLabel}</a>
            </div>
          </div>
        </div>);
      }
});



// WEBPACK FOOTER //
// ./common/pPLogIn.js